
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homeRevision",
      function () {
        return require("private-next-pages/homeRevision/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homeRevision"])
      });
    }
  